import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../base.graphql';

export const approvalFlowStagesFields = `
id
stageUniqueId
stageName
stageIsStarting
stageIsEnding
stageDesignation {
  id
  designationUniqueId
  designationShortForm
  designationName
}
successorStage {
  id
  uuid
  stageName
}
`;



export const GET_ALL_APPROVAL_FLOW_STAGES = gql`
query getApprovalFlowStages($flowUniqueId:String){
    getApprovalFlowStages(flowUniqueId:$flowUniqueId){
    ${baseResponseGraphqlField}
    data {
      ${approvalFlowStagesFields}
    }
  }
}
`;

export const CREATE_APPROVAL_STAGES = gql`
mutation createApprovalFlowStagesMutation($stage: ApprovalFlowStageInputObjects!) {
    createApprovalFlowStagesMutation(stage: $stage) {
    ${baseResponseGraphqlField}
    data {
      ${approvalFlowStagesFields}
    }
  }
}
`;
export const UPDATE_APPROVAL_STAGES = gql`
mutation updateApprovalFlowStagesMutation($stage: ApprovalFlowStageInputObjects!) {
    updateApprovalFlowStagesMutation(stage: $stage) {
    ${baseResponseGraphqlField}
    data {
      ${approvalFlowStagesFields}
    }
  }
}
`;

export const DELETE_APPROVAL_STAGES = gql`
mutation deleteApprovalFlowStagesMutation($stageUniqueId: String!) {
  deleteApprovalFlowStagesMutation(stageUniqueId: $stageUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`;

export const CREATE_APPROVAL_FLOW_SUCCESSOR = gql`
mutation createApprovalFlowStagesSuccessorMutation($successor: ApprovalFlowSuccessorInputObjects!) {
    createApprovalFlowStagesSuccessorMutation(successor: $successor) {
    ${baseResponseGraphqlField}
    data {
      ${approvalFlowStagesFields}
    }
  }
}
`

export const DELETE_APPROVAL_FLOW_SUCCESSOR = gql`
mutation deleteApprovalFlowStagesSuccessorMutation($successorUniqueId: String!) {
  deleteApprovalFlowStagesSuccessorMutation(successorUniqueId: $successorUniqueId) {
    ${baseResponseGraphqlField}
    data {
      ${approvalFlowStagesFields}
    }
  }
}
`

export const UPDATE_APPROVAL_FLOW_SUCCESSOR = gql`
mutation updateApprovalFlowStagesSuccessorMutation($successor: ApprovalFlowSuccessorInputObjects!) {
    updateApprovalFlowStagesSuccessorMutation(successor: $successor) {
    ${baseResponseGraphqlField}
    data {
      ${approvalFlowStagesFields}
    }
  }
}
`
